export default __webpack_public_path__ + "static/media/image-solid.40374613.svg";